import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["options", "formLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { FormControl } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Radio } from '@elements/form';
import { StyledFormLabel, StyledRadioGroup } from './radio-group.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var RadioGroup = function RadioGroup(_ref) {
  var options = _ref.options,
      formLabel = _ref.formLabel,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(FormControl, {
    children: [/*#__PURE__*/_jsx(StyledFormLabel, {
      children: formLabel
    }), /*#__PURE__*/_jsx(StyledRadioGroup, _objectSpread(_objectSpread({}, restProps), {}, {
      children: options && options.map(function (option, index) {
        return /*#__PURE__*/_jsx(FormControlLabel, {
          value: option.value,
          control: /*#__PURE__*/_jsx(Radio, {}),
          label: option.label,
          disabled: option === null || option === void 0 ? void 0 : option.disabled
        }, index);
      })
    }))]
  });
};

RadioGroup.displayName = 'RadioGroup';
export { RadioGroup };